import React, {useEffect, useMemo, useState} from "react";
import "./Home.css";
import {Resolution} from "../logic/FetchResolver";
import {
  ChargingStationsOverrideResponse,
  ChargingStationsResponse,
  PointOfInterest,
} from "../logic/APITypes";
import {getInitialChargingStations} from "../logic/InitialChargingStations";
import {extractChargingStations} from "../logic/extractPOIs";
import {filterChargingStations} from "../logic/filterPOIs";
import {APIProvider, Map, ControlPosition} from "@vis.gl/react-google-maps";
import InfoOverlay from "../components/InfoOverlay";
import GMap from "./GMap";
import Legend from "./Legend";
import API from "../logic/API";
import SearchControls from "./SearchControls";
import LocatorControls from "./LocatorControls";

export type FilterSettings = {
  chargingStations: true;
  constructionSites: false;
  wifiHotspot: false;
  powerType: "AC" | "DC" | "Beides";
  occupancy: "Frei" | "Belegt" | "Beides";
  reachability: "Beschrankt" | "Unbeschrankt" | "Beides";
};

function Home(props: {kiosk?: boolean}) {
  const [filterSettings, setFilterSettings] = useState<FilterSettings>({
    chargingStations: true,
    constructionSites: false,
    wifiHotspot: false,
    powerType: "Beides",
    occupancy: "Beides",
    reachability: "Beides",
  });
  const [openedPoi, setOpenedPoi] = useState<PointOfInterest>();

  const [chargingStationRequest, setChargingStationRequest] = useState<
    Resolution<ChargingStationsResponse>
  >({
    success: true,
    payload: getInitialChargingStations(),
  });
  const [chargingStationsOverrideRequest, setChargingStationsOverrideRequest] =
    useState<Resolution<ChargingStationsOverrideResponse>>({
      success: false,
      unresolved: true,
    });

  const chargingPOIs = useMemo(
    () =>
      chargingStationRequest.payload && chargingStationsOverrideRequest.payload
        ? extractChargingStations(
            chargingStationRequest.payload,
            chargingStationsOverrideRequest.payload,
          )
        : chargingStationRequest.payload
          ? extractChargingStations(chargingStationRequest.payload, {})
          : [],
    [chargingStationRequest.payload, chargingStationsOverrideRequest.payload],
  );

  const mapComponent = useMemo(() => {
    return (
      <>
        <Map
          mapId="619c3cbc51ab0ff9824ff4c4"
          defaultZoom={14}
          defaultCenter={{lat: 49.79, lng: 9.95}}
          fullscreenControl={true}
          streetViewControl={false}
          fullscreenControlOptions={{position: ControlPosition.RIGHT_CENTER}}
          cameraControlOptions={{position: ControlPosition.RIGHT_CENTER}}
        >
          <GMap
            constructionPois={[]}
            chargingPois={
              filterSettings.chargingStations
                ? filterChargingStations(filterSettings, chargingPOIs)
                : []
            }
            wifiPois={[]}
            openPoi={(poi) => setOpenedPoi(poi)}
          />
        </Map>
        <SearchControls />
        <LocatorControls />
        <Legend
          filterSettings={{
            get: filterSettings,
            set: setFilterSettings,
          }}
          constructionRequestFinished={false}
          chargingRequestFinished={!!chargingStationRequest.payload}
          wifiRequestFinished={false}
          kiosk={props.kiosk}
        />
      </>
    );
  }, [chargingPOIs, filterSettings]);

  useEffect(() => {
    API.getChargingStations().then((response) => {
      if (response.payload) setChargingStationRequest(response);
    });
    API.getChargingStationsOverride().then((response) => {
      if (response.payload) setChargingStationsOverrideRequest(response);
    });
  }, []);

  return (
    <div className={"home"}>
      <div className="home__mapContainer">
        <APIProvider apiKey={"AIzaSyBtUCe6Xy0pSx1XcVBlMHzDtvFnD1UGg5g"}>
          {openedPoi && (
            <InfoOverlay
              poi={openedPoi}
              onClose={() => setOpenedPoi(undefined)}
              kiosk={props.kiosk}
            />
          )}
          {mapComponent}
        </APIProvider>
      </div>
    </div>
  );
}

export default Home;
